import { GetServerSideProps } from 'next'
import { createCombinedServerSideProps } from '../src/utils/server/page-props'
import React from 'react'
import { LoggedInPage as LoggedIn } from '../src/page/LoggedIn'
import { ConsumerPage } from '../src/model'
import { getLayout } from '../src/layouts/WhiteBgLayout/WhiteBgLayout'

const I18N_NAMESPACE = ['common']

const LoggedInPage: ConsumerPage = (props) => <LoggedIn {...props} />

LoggedInPage.getLayout = getLayout({ isHideClose: true, fullscreenWhite: true })

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)
export default LoggedInPage
